import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconVer, IconDownLoad } from '../../Icons';
import { RevistaObj } from '../../types/Types';

type Props = {
  revista: RevistaObj;
  onSelectItem: (value: RevistaObj) => void;
};

const RevistasItems: FC<Props> = ({ revista, onSelectItem }) => {
  const { t } = useTranslation();
  const handleClick = () => {
    onSelectItem(revista);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleClickDownLoad = () => {
    const hiddenIFrameID = 'hiddenDownloader';
    let iframe = document.getElementById(hiddenIFrameID);
    if (iframe === null) {
      // eslint-disable-next-line no-const-assign
      iframe = document.createElement('iframe');
      iframe.id = hiddenIFrameID;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const downloadBlob = (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <>
      <div className="col-12 col-sm-6 col-lg-3" key={revista.idRevista}>
        <div className="bloque-revista__container">
          <h3 className="bloque-revista__month u-margin-bottom">
            {revista.mesDeRevista}
          </h3>
          <div className="bloque-revista">
            <div className="img">
              <div>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
                <img
                  onClick={handleClick}
                  src={revista.pathPortada}
                  alt="Portada revista.."
                  className="img "
                />
              </div>
            </div>
            <div className="bloque-revista__actions">
              <div className="bloque-revista__link">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <a onClick={handleClick}>
                  <div className="icon icon-medium icon--brand">
                    <IconVer />
                  </div>
                  <span className="u-margin-left-tiny">
                    {t('revistas.ver')}
                  </span>
                </a>
              </div>
              <div className="bloque-revista__link">
                <a
                  href={revista.pathDescarga}
                  download={revista.pathDescarga}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <div className="icon icon-medium icon--brand">
                    <IconDownLoad />
                  </div>
                  <span className="u-margin-left-tiny">
                    {t('revistas.descargar')}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RevistasItems;
